/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import httpClient from 'utils/httpClient';

export const RETRIEVE_SESSION_URL = (id: string | number | undefined) =>
  `/v2/session/${id}/detail`;

export type HomeworkFile = {
  name: string;
  path: string;
  size: number;
  type: string;
  url: string;
};

export type SessionContentResponse = {
  title: string;
  vocabulary: string;
  grammar: string;
  studentNote: string;
  homework: string;
  bookLessons: string;
  bookName: string;
  bookPages: number;
  bookUnits: string;
  student?: {
    name: string;
    avatarUrl: string;
  };
  homeworkUrl: Array<HomeworkFile>;
  videoUrl: Array<string>;
  homeworkResultUrl: Array<any>;
  link: string;
  teacherCheckIn: string;
  teacherCheckOut: string;
};

export type RetrieveSessionContentQuery = {
  id: string | number;
  isUnit: boolean;
};

export const retrieveSessionContent = ({
  id,
  isUnit,
}: RetrieveSessionContentQuery) => {
  let params = {};
  if (isUnit) {
    params = {
      'is-unit': isUnit,
    };
  }
  return httpClient.get<SessionContentResponse>(RETRIEVE_SESSION_URL(id), {
    params,
  });
};

export const useRetrieveSessionContent = (
  { id, isUnit }: RetrieveSessionContentQuery,
  opts?: UseQueryOptions<
    AxiosResponse<SessionContentResponse>,
    AxiosError<any>
  >,
) =>
  useQuery<AxiosResponse<SessionContentResponse>, AxiosError<any>>(
    [RETRIEVE_SESSION_URL(id)],
    () => retrieveSessionContent({ id, isUnit }),
    { ...opts, cacheTime: 1 },
  );
